<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>
                <div class="col-xl-9">
                    <div class="box-shadow">
                        <div class="container-news">
                            <h1 class="as-h2 mb-28">Новости</h1>
                            <div class="grid-container" v-if="news && news.length > 0">
                                <div class="box-grid" v-for="item in news">
                                    <news-app :item="item"></news-app>
                                </div>
                            </div>
                            <div class="to-all-items cursor-pointer" v-if="totalRow > 0" @click="init()">Смотреть еще</div>
                        </div>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                breadcrumb: [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: 'Новости',
                        active: true
                    }
                ],
                news: [],
                count: 0,
                seo_text: null
            }
        },
        computed: {
            totalRow() {
                return this.count - this.news.length
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                let url = '/api/news';
                let params = {'offset': this.news.length};
                axios.get(url, {params})
                    .then(response => {
                        this.news = this.news.concat(response.data.news);
                        this.count = response.data.count;
                        let seoInfo = response.data.seoInfo
                        this.seo_text = response.data.seoInfo.seo_text

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Новости Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Следите за новостями поставок новой техники и оборудования, а также спецпроектов.';
                        document.querySelector('meta[property="og:title"]').setAttribute("content",  title);
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
            },
        }
    }
</script>

